import React from "react";

import { CollapseHeader, FormCollapse } from "components/Form";
import { FinanceSubModalSection } from "constants/settings";
import { SectionToggleState, useSectionHelper } from "hooks";

import { Grid } from "@material-ui/core";

import { Label } from "components/Form/FormikControls";
import { SplitAllocationForm } from "components/TransactionSplits/SplitAllocationForm";
import { SplitOrigin } from "constants/splits";

interface BusinessVendorSplitsSectionProps {
  sectionHelper: SectionToggleState;
}

export const BusinessVendorSplitsSection: React.FC<
  BusinessVendorSplitsSectionProps
> = ({ sectionHelper }) => {
  const { isOpen, onToggle } = useSectionHelper(
    sectionHelper,
    FinanceSubModalSection.VENDOR_SPLITS,
  );

  const header = <CollapseHeader title="Vendor Splits" />;

  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={header}
      dataTour="vendorSplitsCollapse"
    >
      <Grid data-tour="defaultVendorSplits" container spacing={2} item xs={12}>
        <Grid item xs={12}>
          <Label>Default Vendor Splits</Label>
        </Grid>
        <SplitAllocationForm
          namespace="defaultVendorSplit"
          splitType={SplitOrigin.VENDOR}
        />
      </Grid>
    </FormCollapse>
  );
};
